import { Component } from '@angular/core';
import { InputGLobal } from '../utils/input-global';

@Component({
  selector: 'lib-input-color',
  templateUrl: './input-color.component.html',
  styleUrl: './input-color.component.scss',
})
export class InputColorComponent extends InputGLobal {

  swatchColor(): string {
    const val = this.formControl?.value ?? '';
    return isValidHex(val) ? val : 'transparent';
  }

  pickerValue(): string {
    const val = this.formControl?.value ?? '';
    return expandToFullHex(val) ?? '#000000';
  }

  onPickerInput(event: Event): void {
    const hex = (event.target as HTMLInputElement).value;
    if (!this.formControl) return;
    this.formControl.setValue(hex, { emitEvent: true });
    this.formControl.markAsDirty();
  }
}

function isValidHex(value: string): boolean {
  return /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(value);
}

function expandToFullHex(value: string): string | null {
  if (/^#[0-9a-fA-F]{6}$/.test(value)) return value;
  if (/^#[0-9a-fA-F]{3}$/.test(value)) {
    const [, r, g, b] = value;
    return `#${r}${r}${g}${g}${b}${b}`;
  }
  return null;
}
